
import { defineComponent } from 'vue'

import NewslettersSignup from '~/components/NewslettersSignup/NewslettersSignup.vue'
import AppImage from '~/components/AppImage/AppImage.vue'

export default defineComponent({
  name: 'NewslettersSignupSection',
  components: {
    AppImage,
    NewslettersSignup,
  },
  computed: {
    pictures () {
      if (this.$mqUtils.isMobile) {
        return [
          require('~/assets/images/newsletters-signup/newsletters-signup-bg-mobile.webp'),
          require('~/assets/images/newsletters-signup/newsletters-signup-bg-mobile@2x.webp'),
        ]
      }

      return [
        require('~/assets/images/newsletters-signup/newsletters-signup-bg.webp'),
      ]
    },
  },
})
